module.exports = __webpack_public_path__ + "img/connect_1on1N.db218338.png";